import { PageLayout } from '@plm-core/utils'
import TeamsView from 'teams/components/view/TeamsView'
import { Breadcrumbs, Layout } from '@design-systems/canvas-ui'
import { useQuery } from '@apollo/client/react'
import { useNavigate, useParams } from 'react-router-dom'
import { GET_TEAMS_BY_IDS } from 'graphql/queries/teams/teamsQueries'

const TeamsViewPage = () => {
  const { teamId } = useParams<{ teamId: string }>()
  const navigate = useNavigate()

  // todo: handle error state later
  const { data, loading, refetch } = useQuery(GET_TEAMS_BY_IDS, {
    variables: { ids: [teamId] },
    skip: !teamId,
  })

  const team = data?.getTeams?.[0]
  const breadcrumbItem = team?.teamName || teamId

  return (
    <>
      <Layout.PageHeader>
        <PageLayout>
          <Breadcrumbs>
            <Breadcrumbs.Item onClick={() => navigate('/teams')}>
              Teams
            </Breadcrumbs.Item>
            <Breadcrumbs.Item>{breadcrumbItem}</Breadcrumbs.Item>
          </Breadcrumbs>
        </PageLayout>
      </Layout.PageHeader>
      <PageLayout withPageHeader>
        <TeamsView team={team} loading={loading} refetchTeam={refetch} />
      </PageLayout>
    </>
  )
}

export default TeamsViewPage
